import {
  AllProductsIcon,
  ExtractIcon,
  FlowerIcon,
  GearIcon,
  GrowIcon,
  GummyIcon,
  JaneGoldIcon,
  MerchIcon,
  PrerollIcon,
  StarFilledIcon,
  TagFilledIcon,
  TinctureIcon,
  TopicalIcon,
  VapeIcon,
} from '@iheartjane/reefer';
import type { ColorKey, IconComponent } from '@iheartjane/reefer';
import type { MenuTab } from '@iheartjane/types';

import edible from './assets/default-edible.png';
import extract from './assets/default-extract.png';
import flower from './assets/default-flower.png';
import gear from './assets/default-gear.png';
import grow from './assets/default-grow.png';
import merch from './assets/default-merch.png';
import preRoll from './assets/default-pre-roll.png';
import tincture from './assets/default-tincture.png';
import topical from './assets/default-topical.png';
import vape from './assets/default-vape.png';

interface MenuCategory {
  Icon: IconComponent;
  iconColor?: ColorKey;
  image?: string;
}

export const MENU_CATEGORY_TABS: Record<MenuTab, MenuCategory> = {
  featured: {
    Icon: StarFilledIcon,
    iconColor: 'primary',
  },
  specials: {
    Icon: TagFilledIcon,
    iconColor: 'info',
  },
  brand_specials: {
    Icon: JaneGoldIcon,
    iconColor: 'gold',
  },
  flower: {
    Icon: FlowerIcon,
    image: flower,
  },
  edible: {
    Icon: GummyIcon,
    image: edible,
  },
  'pre-roll': {
    Icon: PrerollIcon,
    image: preRoll,
  },
  extract: {
    Icon: ExtractIcon,
    image: extract,
  },
  tincture: {
    Icon: TinctureIcon,
    image: tincture,
  },
  topical: {
    Icon: TopicalIcon,
    image: topical,
  },
  vape: {
    Icon: VapeIcon,
    image: vape,
  },
  merch: {
    Icon: MerchIcon,
    image: merch,
  },
  gear: {
    Icon: GearIcon,
    image: gear,
  },
  grow: {
    Icon: GrowIcon,
    image: grow,
  },
  'all-products': {
    Icon: AllProductsIcon,
  },
};
